import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';
import { FormattedMessage } from 'react-intl';

import NotificationPanel from './NotificationPanel';

import styles from '../../../styles/partials/no-results.module.scss';

const propTypes = {
    className: PropTypes.string,
    isDark: PropTypes.bool,
};

const defaultProps = {
    className: null,
    isDark: false,
};

const NoFilms = ({ className, isDark }) => (
    <NotificationPanel
        className={classNames([
            styles.container,
            {
                [className]: className !== null,
                [styles.isDark]: isDark,
            },
        ])}
        label={
            <FormattedMessage
                defaultMessage="No films found for these filters."
                description="Notification"
            />
        }
    />
);
NoFilms.propTypes = propTypes;
NoFilms.defaultProps = defaultProps;

export default NoFilms;
